import { status } from '../utils';

export function auth(credentials){
  return fetch(`${process.env.REACT_APP_API_URL}/authenticate/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(credentials)
  }).then(status).catch( e => {console.log(e)})
}

export function register(userData){
  return fetch(`${process.env.REACT_APP_API_URL}/users/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(userData)
  }).then(status).catch( e => {console.log(e)})
}

export function changePass(userData, userId, token){
  return fetch(`${process.env.REACT_APP_API_URL}/users/${userId}/change_pass/`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
    body: JSON.stringify(userData)
  }).then(status).catch( e => {console.log(e)})
}

export function uploadAvatar(profileId, data){
  return fetch(`${process.env.REACT_APP_API_URL}/profile/${profileId}/`, {
    method: 'PUT',
    body: data
  }).then(status).catch( e => {console.log(e)})
}